import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AiBuddyChatRoleDescriptionTemplate, AiBuddyTemplate, ImageTypeTemplate, LiveAvatarTemplate, Model3dTypeTemplate, VideoTypeTemplate } from './asset-item.constant';
import { AssetType } from 'src/app/_models/AssetType';
import { MmitaAssetService } from 'src/app/_services/mmitaAsset.service';
import { Observable } from 'rxjs';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { Global } from 'src/app/_services/global.service';
import { AssetWriteDto } from 'src/app/_models/assetWriteDto';

@Component({
  selector: 'app-ant-asset-item',
  templateUrl: './ant-asset-item.component.html',
  styleUrls: ['./ant-asset-item.component.css']
})
export class AntAssetItemComponent implements OnInit {
  private readonly aiBuddyChatRoleSupportedTypes = ['AiBuddy', 'LiveAvatar2D']
  readonly source!: any
  readonly copyMode!: boolean
  readonly data!: any
  readonly isBatch!: boolean
  readonly section = this.global.section
  formGroup!: FormGroup
  dialogFields: any[] = []
  callback!: () => Observable<unknown>
  get abilitiesVoiceControllable() {
    return !!this.formGroup?.get('abilitiesVoiceControllable')?.value
  }
  constructor(
    private assetService: MmitaAssetService,
    private nzModalRef: NzModalRef,
    private global: Global,
  ) { }

  ngOnInit(): void {
    this.initForm()
    this.callback = () => this.onSubmit.call(this)
  }

  private initForm() {
    this.genFG()
    this.setFormStatus(this.formGroup.value.assetType)
    this.setVirtualMallField(this.formGroup.value.businessType)
  }

  genDialogField(field: any) {
    if (this.isBatch) {
      return field.filter((item: any) => {
        return item.key !== 'name' && item.key !== 'description'
      })
    }
    return field
  }

  setFormStatus(assetType: any, requiredVisionOS: boolean = false) {
    if (this.isBatch) {
      this.formGroup?.get('name')?.disable()
      this.formGroup?.get('description')?.disable()
    }
    switch (assetType) {
      case AssetType.Image:
        this.dialogFields = this.genDialogField(ImageTypeTemplate(this.source, this.isBatch))
        this.setAiField(this.formGroup?.get('businessType')?.value)
        this.setAiBuddyChatRoleDescriptionField(this.formGroup?.get('businessType')?.value)
        this.setLiveAvatarField(this.formGroup?.get('businessType')?.value)
        this.formGroup?.get('thumbnailUrl')?.disable()
        this.formGroup?.get('androidUrl')?.disable()
        this.formGroup?.get('visionOSUrl')?.disable()
        this.formGroup?.get('macOSUrl')?.disable()
        this.formGroup?.get('miniUrl')?.disable()
        this.formGroup?.get('androidMiniUrl')?.disable()
        break;
      case AssetType.Video:
        this.dialogFields = this.genDialogField(VideoTypeTemplate(this.source, this.isBatch))
        this.setAiField(this.formGroup?.get('businessType')?.value)
        this.setAiBuddyChatRoleDescriptionField(this.formGroup?.get('businessType')?.value)
        this.setLiveAvatarField(this.formGroup?.get('businessType')?.value)
        this.formGroup?.get('thumbnailUrl')?.enable()
        this.formGroup?.get('androidUrl')?.disable()
        this.formGroup?.get('visionOSUrl')?.disable()
        this.formGroup?.get('macOSUrl')?.disable()
        this.formGroup?.get('miniUrl')?.disable()
        this.formGroup?.get('androidMiniUrl')?.disable()
        break;
      case AssetType.Model3d:
        this.dialogFields = this.genDialogField(Model3dTypeTemplate(this.source, this.isBatch, requiredVisionOS, () => this.abilitiesVoiceControllable))
        this.setAiField(this.formGroup?.get('businessType')?.value)
        this.setAiBuddyChatRoleDescriptionField(this.formGroup?.get('businessType')?.value)
        this.setLiveAvatarField(this.formGroup?.get('businessType')?.value)
        this.formGroup?.get('thumbnailUrl')?.enable()
        this.formGroup?.get('androidUrl')?.enable()
        this.formGroup?.get('visionOSUrl')?.enable()
        this.formGroup?.get('macOSUrl')?.enable()
        this.formGroup?.get('miniUrl')?.enable()
        this.formGroup?.get('androidMiniUrl')?.enable()
        break;
    }
  }

  setAiField(businessType: string) {
    const aiBuddyKeys = AiBuddyTemplate(this.section.AssetAiBuddyVoiceTypeSelections, this.source.voiceList).map(field => field.key);
    const alreadyExists = this.dialogFields.some(field => aiBuddyKeys.includes(field.key));

    if (businessType === 'AiBuddy') {
      if (!alreadyExists) {
        this.dialogFields = [...this.dialogFields, ...AiBuddyTemplate(this.section.AssetAiBuddyVoiceTypeSelections, this.source.voiceList)];
      }
    } else {
      this.dialogFields = this.dialogFields.filter(field => !aiBuddyKeys.includes(field.key));
    }
  }

  setAiBuddyChatRoleDescriptionField(businessType: string) {
    const keys = AiBuddyChatRoleDescriptionTemplate().map(f => f.key);
    const alreadyExists = this.dialogFields.some(f => keys.includes(f.key));
    if (this.aiBuddyChatRoleSupportedTypes.includes(businessType)) {
      if (!alreadyExists) {
        this.dialogFields = [...this.dialogFields, ...AiBuddyChatRoleDescriptionTemplate()];
      }
    } else {
      this.dialogFields = this.dialogFields.filter(f => !keys.includes(f.key));
    }
  }

  setLiveAvatarField(businessType: string) {
    const liveAvatarKeys = LiveAvatarTemplate().map(field => field.key);
    const alreadyExists = this.dialogFields.some(field => liveAvatarKeys.includes(field.key));

    if (businessType === 'LiveAvatar2D') {
      if (!alreadyExists) {
        this.dialogFields = [...this.dialogFields, ...LiveAvatarTemplate()];
      }
    } else {
      this.dialogFields = this.dialogFields.filter(field => !liveAvatarKeys.includes(field.key));
      this.formGroup.patchValue({
        liveAvatarProvider: 'LiveAvatar',
        liveAvatarAvatarId: null,
        liveAvatarContextId: null,
        liveAvatarVoiceId: null,
        liveAvatarLanguage: 'en',
        liveAvatarIsSandbox: false,
        liveAvatarMaxSessionDuration: 120,
        liveAvatarIdleVideo: null,
      });
    }
  }

  setVirtualMallField(businessType: string) {
    if (businessType === 'VirtualMall') {
      this.formGroup?.get('virtualMallId')?.enable()
    } else {
      this.formGroup?.get('virtualMallId')?.disable()
      this.formGroup?.get('virtualMallId')?.setValue(null)
    }
  }


  genFG() {
    this.formGroup = new FormGroup({
      assetType: new FormControl(this.data?.assetType || AssetType.Image, Validators.required),
      categoryId: new FormControl(this.data?.category?.id, Validators.required),
      scaleInMap: new FormControl(this.data?.scaleInMap || 1, [Validators.required, Validators.min(0)]),
      abilitiyIds: new FormControl(this.data?.abilitiyIds || []),
      name: new FormControl(this.data?.name, Validators.required),
      description: new FormControl(this.data?.description),
      numberOfTokensUnlocked: new FormControl(this.data?.numberOfTokensUnlocked || 0, [Validators.required, Validators.min(0)]),
      adUrlLinked: new FormControl(this.data?.adUrlLinked),
      assetStatus: new FormControl(this.data?.assetStatus || 'Inactive', [Validators.required]),
      businessType: new FormControl(this.data?.businessType, Validators.required),
      url: new FormControl(this.data?.file?.url, Validators.required),
      thumbnailUrl: new FormControl(this.data?.thumbnail?.url, Validators.required),
      androidUrl: new FormControl(this.data?.androidFile?.url),
      visionOSUrl: new FormControl(this.data?.visionOSFile?.url),
      macOSUrl: new FormControl(this.data?.macOSFile?.url),
      miniUrl: new FormControl(this.data?.miniFile?.url),
      androidMiniUrl: new FormControl(this.data?.androidMiniFile?.url),
      tags: new FormControl(this.data?.tags?.map((item: any) => item.name)),
      aiBuddyChatRoleDescription: new FormControl(this.data?.aiBuddyChatRoleDescription),
      abilitiesVoiceControllable: new FormControl(this.data?.abilitiesVoiceControllable || false),
      aiBuddyVoiceRolesUS: new FormControl(this.data?.multilingualAiBuddyVoiceRoles?.['en-US']),
      aiBuddyVoiceRolesCN: new FormControl(this.data?.multilingualAiBuddyVoiceRoles?.['zh-CN']),
      aiBuddyVoiceRolesHK: new FormControl(this.data?.multilingualAiBuddyVoiceRoles?.['zh-HK']),
      aiBuddyVoiceRolesES: new FormControl(this.data?.multilingualAiBuddyVoiceRoles?.['es-ES']),
      aiBuddyPersonalVoiceSpeakerProfileId: new FormControl(this.data?.aiBuddyPersonalVoiceSpeakerProfileId),
      aiBuddyVoiceType: new FormControl(this.data?.aiBuddyVoiceType || 'VoiceRole'),
      virtualMallId: new FormControl(this.data?.virtualMallId, Validators.required),
      liveAvatarProvider: new FormControl(this.data?.liveAvatarInfo?.provider || 'LiveAvatar'),
      liveAvatarAvatarId: new FormControl(this.data?.liveAvatarInfo?.avatarId),
      liveAvatarContextId: new FormControl(this.data?.liveAvatarInfo?.contextId),
      liveAvatarVoiceId: new FormControl(this.data?.liveAvatarInfo?.voiceId),
      liveAvatarLanguage: new FormControl(this.data?.liveAvatarInfo?.language || 'en'),
      liveAvatarIsSandbox: new FormControl(this.data?.liveAvatarInfo?.isSandbox ?? false),
      liveAvatarMaxSessionDuration: new FormControl(this.data?.liveAvatarInfo?.maxSessionDuration ?? 120),
      liveAvatarIdleVideo: new FormControl(this.data?.liveAvatarInfo?.idleVideo?.url),
    })
    this.formGroup?.get('assetType')?.valueChanges.subscribe(res => {
      this.setFormStatus(res)
      this.resetUrlField()
    })
    this.formGroup?.get('categoryId')?.valueChanges.subscribe(res => {
      const requiredVisionOS = this.isRequiredVisionOS()
      this.setFormStatus(this.formGroup.value.assetType, requiredVisionOS)
      this.resetUrlField()
      requiredVisionOS ? this.formGroup?.get('visionOSUrl')?.setValidators(Validators.required) : this.formGroup?.get('visionOSUrl')?.setValidators(null)
    })

    this.formGroup?.get('abilitiesVoiceControllable')?.valueChanges.subscribe(abilitiesVoiceControllable => {
      const requiredVisionOS = this.isRequiredVisionOS()
      this.setFormStatus(this.formGroup.value.assetType, requiredVisionOS)
      abilitiesVoiceControllable ? this.formGroup?.get('abilitiyIds')?.setValidators(Validators.required) : this.formGroup?.get('abilitiyIds')?.removeValidators(Validators.required)
    })


    this.formGroup?.get('businessType')?.valueChanges.subscribe(res => {
      this.setVirtualMallField(res)
      this.setAiField(res)
      this.setAiBuddyChatRoleDescriptionField(res)
      this.setLiveAvatarField(res)
      if (!this.aiBuddyChatRoleSupportedTypes.includes(res)) {
        this.formGroup?.get('aiBuddyChatRoleDescription')?.setValue(null, { emitEvent: false });
      }
    });


    this.data && !this.copyMode && this.formGroup?.get('categoryId')?.disable()
    !this.isBatch && !this.data && this.autoApplyFileSource()
  }

  private isRequiredVisionOS() {
    const selectedCat = this.source.categoryFilterByType[AssetType.Model3d].find((item: any) => {
      return item.id === this.formGroup?.get('categoryId')?.value
    })
    return selectedCat?.assetCategoryOptions?.indexOf('VisionOS') >= 0
  }

  resetUrlField() {
    this.formGroup.patchValue({ url: this.data?.file?.url })
    this.formGroup.patchValue({ thumbnailUrl: this.data?.thumbnail?.url })
    this.formGroup.patchValue({ androidUrl: this.data?.androidFile?.url })
    this.formGroup.patchValue({ visionOSUrl: this.data?.visionOSFile?.url })
    this.formGroup.patchValue({ macOSUrl: this.data?.macOSFile?.url })
    this.formGroup.patchValue({ miniUrl: this.data?.miniFile?.url })
    this.formGroup.patchValue({ androidMiniUrl: this.data?.androidMiniFile?.url })
  }

  autoApplyFileSource() {
    const watchList = ['url', 'androidUrl', 'visionOSUrl', 'macOSUrl', 'miniUrl', 'androidMiniUrl']
    const toAutoFillInCtrl = (item: any) => {
      const checkList = watchList.filter((watchItem) => watchItem !== item);
      let nullFlag = true
      checkList.forEach(watchItem => {
        if (this.formGroup.value[watchItem] && this.formGroup.value[watchItem] instanceof Array && this.formGroup.value[watchItem].length > 0) {
          nullFlag = false
        }
      })
      return nullFlag ? checkList : null
    }
    watchList.forEach(item => {
      this.formGroup?.get(item)?.valueChanges.subscribe(uploaded => {
        if (this.formGroup.value.assetType !== AssetType.Model3d || !uploaded || !uploaded?.length || uploaded[0]?.file?.name.indexOf('.glb') < 0) {
          return
        }
        const fillInCtrlName = toAutoFillInCtrl(item)
        fillInCtrlName && fillInCtrlName.forEach(fillItem => {
          setTimeout(() => {
            this.formGroup.patchValue({ [fillItem]: uploaded })
          }, 400)
        })
      })
    })
  }

  private buildfinalFG() {
    const _fgValue = {
      ...this.formGroup.value,
      aiBuddyChatRoleDescription: this.aiBuddyChatRoleSupportedTypes.includes(this.formGroup.value.businessType)
        ? this.formGroup.value.aiBuddyChatRoleDescription
        : null,
      multilingualAiBuddyVoiceRoles: {
        'en-US': this.formGroup.value.aiBuddyVoiceRolesUS,
        'zh-CN': this.formGroup.value.aiBuddyVoiceRolesCN,
        'zh-HK': this.formGroup.value.aiBuddyVoiceRolesHK,
        'es-ES': this.formGroup.value.aiBuddyVoiceRolesES
      },
      liveAvatarInfo: this.formGroup.value.businessType === 'LiveAvatar2D' ? {
        provider: this.formGroup.value.liveAvatarProvider,
        avatarId: this.formGroup.value.liveAvatarAvatarId,
        contextId: this.formGroup.value.liveAvatarContextId,
        voiceId: this.formGroup.value.liveAvatarVoiceId,
        language: this.formGroup.value.liveAvatarLanguage,
        isSandbox: this.formGroup.value.liveAvatarIsSandbox,
        maxSessionDuration: this.formGroup.value.liveAvatarMaxSessionDuration,
        idleVideo: (() => {
          const raw = this.formGroup.value.liveAvatarIdleVideo;
          const v = Array.isArray(raw) ? raw[0] : raw;
          if (!v) return null;
          if (v?.origin?.url) return { url: v.origin.url, size: v.size, format: v.format };
          return this.data?.liveAvatarInfo?.idleVideo || null;
        })()
      } : null
    }
    return _fgValue
  }

  onSubmit() {
    return new Observable(subscriber => {
      const saveSuccess = () => {
        this.nzModalRef.triggerOk()
        subscriber.next()
        subscriber.complete()
      }
      const finalFG = this.buildfinalFG()
      if (this.isBatch) {
        const data = this.genBatchAsset(finalFG) as Array<AssetWriteDto>
        this.assetService.batchaddAsset(data).subscribe({
          next: x => saveSuccess(),
          error: x => subscriber.error(x)
        })
      } else {
        const data = { ...finalFG, ...this.imageUrlMapping(finalFG.assetType) }
        this.data?.id && !this.copyMode ? this.assetService.updateAsset(data, this.data.id).subscribe({
          next: x => saveSuccess(),
          error: x => subscriber.error(x)
        }) : this.assetService.addAsset(data).subscribe({
          next: x => saveSuccess(),
          error: x => subscriber.error(x)
        })
      }
    })
  }


  private genBatchAsset(finalFG: any) {
    const urlData = finalFG.url
    if (Array.isArray(urlData) && urlData.length > 0) {
      return urlData.map((item, index) => {
        return { ...finalFG, ...this.imageUrlMapping(finalFG.assetType, index) }
      })
    }
    return
  }

  private imageUrlMapping(assetType: any, index = 0) {
    const urlData = this.formGroup.value.url
    const urlItem = Array.isArray(urlData) ? urlData[index] : urlData
    const thumData = this.formGroup.value.thumbnailUrl
    const thumItem = Array.isArray(thumData) ? thumData[index] : thumData

    switch (assetType) {
      case AssetType.Image:
        if (urlItem.format === 'gif') {
          const gifThumData = this.formGroup?.get('thumbnailUrl')?.value
          const gifThumItem = Array.isArray(gifThumData) ? gifThumData[index] : gifThumData
          return {
            url: urlItem?.origin?.url || this.data?.file?.url,
            thumbnailUrl: gifThumItem?.medium?.url || this.data?.thumbnail?.url,
            smallThumbnailUrl: gifThumItem?.small?.url || this.data?.smallThumbnail?.url,
            iconUrl: gifThumItem?.icon?.url || this.data?.icon?.url,
          }
        } else {
          return {
            url: urlItem?.medium?.url || this.data?.file?.url,
            thumbnailUrl: urlItem?.medium?.url || this.data?.thumbnail?.url,
            smallThumbnailUrl: urlItem?.small?.url || this.data?.smallThumbnail?.url,
            iconUrl: urlItem?.icon?.url || this.data?.icon?.url,
          }
        }

      case AssetType.Video:
        return {
          url: urlItem?.origin?.url || this.data?.file?.url,
          thumbnailUrl: thumItem?.medium?.url || this.data?.thumbnail?.url,
          smallThumbnailUrl: thumItem?.small?.url || this.data?.smallThumbnail?.url,
          iconUrl: thumItem?.icon?.url || this.data?.icon?.url,
        }
      case AssetType.Model3d:
        const androidItem = Array.isArray(this.formGroup.value.androidUrl) ? this.formGroup.value.androidUrl[index] : this.formGroup.value.androidUrl
        const visionItem = Array.isArray(this.formGroup.value.visionOSUrl) ? this.formGroup.value.visionOSUrl[index] : this.formGroup.value.visionOSUrl
        const macItem = Array.isArray(this.formGroup.value.macOSUrl) ? this.formGroup.value.macOSUrl[index] : this.formGroup.value.macOSUrl
        const miniItem = Array.isArray(this.formGroup.value.miniUrl) ? this.formGroup.value.miniUrl[index] : this.formGroup.value.miniUrl
        const androidMiniItem = Array.isArray(this.formGroup.value.androidMiniUrl) ? this.formGroup.value.androidMiniUrl[index] : this.formGroup.value.androidMiniUrl
        return {
          url: urlItem?.origin?.url || this.data?.file?.url,
          thumbnailUrl: thumItem?.medium?.url || this.data?.thumbnail?.url,
          smallThumbnailUrl: thumItem?.small?.url || this.data?.smallThumbnail?.url,
          iconUrl: thumItem?.icon?.url || this.data?.icon?.url,
          androidUrl: androidItem?.origin?.url || this.data?.androidFile?.url,
          visionOSUrl: visionItem?.origin?.url || this.data?.visionOSFile?.url,
          macOSUrl: macItem?.origin?.url || this.data?.macOSFile?.url,
          miniUrl: miniItem?.origin?.url || this.data?.miniFile?.url,
          androidMiniUrl: androidMiniItem?.origin?.url || this.data?.androidMiniFile?.url,
        }
    }

  }





}
